import Parameter from '../../Parameter';
import { cheerioLoad } from '../../../../../../lib/cheerio/cheerio';
import { LinkchooserLinkType } from '../../../../../../types/api/LinkchooserLinkType';

export default class RichText extends Parameter {
  /**
   * Replacing a11y conform links in RichText payload to normal anchors with data attributes
   * to not store design/look and feel relevant information, that might change over time, in the database.
   * This keeps the database clean and allows us to change the appearance of a11y conform links to our needs,
   * when ever needed. Even for already existing customer content.
   */
  public getPayloadValue(): { name: string; value: string } {
    const { name, value } = super.getPayloadValue();

    // no value -> empty rich text, must be savable nonetheless
    if (!value) {
      return { name, value: '' };
    }

    // isDocument parameter of cheerio load is set to false as to avoid body, head and other tags being added by cheerio
    const $ = cheerioLoad(value);

    $('a').each((index: number, element) => {
      if (
        element.attribs['data-breed'] === LinkchooserLinkType.Attachment ||
        element.attribs['data-link-type'] === LinkchooserLinkType.Attachment
      ) {
        $(element)
          .removeAttr('class data-reactroot')
          .find('span')
          .each((i: number, e) => {
            // @ts-expect-error as firstChild exists
            let linkContent = e.firstChild.data;

            if (linkContent.endsWith('(')) {
              linkContent = linkContent.replace('(', '').trim();
            }

            $(e).replaceWith(linkContent);
          });
      }
    });

    return { name, value: $.html().replace(/&nbsp;/gm, ' ') };
  }
}
